<nb-card class="dialog-card">
  <nb-card-header>
    <h4>{{ "pages.skills.library.title" | translate }}</h4>
  </nb-card-header>
  <nb-card-body>
    <p class="hint">{{ "pages.skills.library.intro" | translate }}</p>

    <div class="filters">
      <app-search-input
        class="filters__search"
        [value]="query"
        (valueChange)="onQuery($event)"
        placeholderKey="pages.skills.library.searchPlaceholder"
      ></app-search-input>
      <nb-select size="small" class="filters__source" [(selected)]="source" (selectedChange)="onFilter()"
        [nbTooltip]="'pages.skills.library.tooltips.collection' | translate">
        <nb-option value="all">{{ "pages.skills.library.allSources" | translate }}</nb-option>
        <nb-option *ngFor="let s of sources" [value]="s.id">{{ sourceLabel(s.id) }}</nb-option>
      </nb-select>
      <nb-checkbox [(checked)]="codeFree" (checkedChange)="onFilter()"
        [nbTooltip]="'pages.skills.library.tooltips.codeFree' | translate">
        {{ "pages.skills.library.codeFree" | translate }}
      </nb-checkbox>
    </div>

    <div class="results" [nbSpinner]="loading">
      <nb-list *ngIf="results.length">
        <nb-list-item *ngFor="let s of results; trackBy: trackItem">
          <app-library-skill-item
            [skill]="s"
            [sourceLabel]="sourceLabel(s.source)"
            [busy]="importing === s.path"
            (importClick)="importSkill($event)"
          ></app-library-skill-item>
        </nb-list-item>
      </nb-list>
      <p class="hint" *ngIf="!loading && !results.length">
        {{ (indexed ? "pages.skills.library.empty" : "pages.skills.library.notIndexed") | translate }}
      </p>
      <button *ngIf="hasMore" nbButton size="small" status="basic" type="button" class="more" (click)="load(false)"
        [disabled]="loading">
        {{ "pages.skills.library.more" | translate }}
      </button>
    </div>

    <p class="hint">{{ "pages.skills.importDialog.inactiveNote" | translate }}</p>
    <div class="error-box" *ngIf="error" role="alert">
      <nb-icon icon="alert-circle-outline"></nb-icon>
      <span>{{ error }}</span>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="basic" size="small" type="button" (click)="close()">
      {{ "buttons.close" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
